import React from 'react';
import PropTypes from 'prop-types';

const NormalPlayPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M23.997 12.003H3a1 1 0 0 0-1 1v6.001a1 1 0 0 0 1 .999h20.997v4.022c0 .313.146.567.395.755.439.335 1.067.29 1.4-.15l6.004-8.022a1 1 0 0 0 0-1.21l-6.003-8.023A.983.983 0 0 0 24.997 7c-.552 0-1 .429-1 .98v4.023z"
    />
  );
};

NormalPlayPath.propTypes = {
  fill: PropTypes.string,
};

export default NormalPlayPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/media-playback/normal-play.jsx